import { api } from '../apiSlice';

export const notificationApi = api
  .enhanceEndpoints({ addTagTypes: ['Notification'] })
  .injectEndpoints({
    endpoints: build => ({

      getNotifications: build.query({
        query: (params) => {
          const queryString = new URLSearchParams(params).toString();
          return `/users/${params.user_id}/notifications?${queryString}`;
        },
        providesTags: ['Notification']
      }),

      clearAllNofiications: build.mutation({
        query: (params) => ({
          url: `/users/${params.user_id}/notifications/clear_all?${new URLSearchParams(params).toString()}`,
          method: 'POST'
        }),
        invalidatesTags: ['Notification']
      }),

      clearOneNotification: build.mutation({
        query: (params) => ({
          url: `/users/${params.user_id}/notifications/clear?${new URLSearchParams(params).toString()}`,
          method: 'POST'
        }),
        invalidatesTags: ['Notification']
      }),

    }),
  });

export const {
  useGetNotificationsQuery,
  useClearAllNofiicationsMutation,
  useClearOneNotificationMutation,
} = notificationApi;
